
import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import { getSubProductConfig } from '@/api/product/productAccount'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'sub-product',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) subProduct!: any

  get language() {
    return AppModule.language
  }
  private activeNames: string | number = ''

  private loading: boolean = false
  private subProductData: any = {
    extra_param: {
      product_sub_switch: 0,
      product_sub_rate_list: [
        {
          product_sub_code: '',
          rate_list: [],
          billing_type: 'D',
          billing_cycle: 0
        }
      ]
    }
  }

  private back() {
    this.subProductData = this.subProduct
    this.$emit('close', false)
  }
  private addRateConfig(item: any) {
    const lastIndex = item.rate_list.length - 1
    let newMinAmount = 0

    // 如果存在上一项，则新项的min_amount = 上一项max_amount + 1
    if (lastIndex >= 0 && item.rate_list[lastIndex].max_amount) {
      newMinAmount = Number(item.rate_list[lastIndex].max_amount) + 1
    }

    item.rate_list.push({
      rate: 0,
      min_fee: 0,
      fixed_fee: 0,
      max_amount: newMinAmount + 100000, // 初始max_amount与min_amount相同或可设为更大值
      min_amount: newMinAmount
    })
  }
  private removeRateConfig(item: any, index: number) {
    item.rate_list.splice(index, 1)
  }

  private validateRateList(): boolean {
    for (const product of this.subProductData.extra_param
      .product_sub_rate_list) {
      for (let i = 0; i < product.rate_list.length; i++) {
        const current = product.rate_list[i]

        // 确保 max_amount >= min_amount
        if (Number(current.max_amount) < Number(current.min_amount)) {
          this.$message({
            message: this.$t('product.amount_range_error') as string,
            type: 'error'
          })
          return false
        }

        // 确保当前项 min_amount 比前一项 max_amount 大
        if (i > 0) {
          const previous = product.rate_list[i - 1]
          if (Number(current.min_amount) <= Number(previous.max_amount)) {
            this.$message({
              message: this.$t('product.amount_continuity_error') as string,
              type: 'error'
            })
            return false
          }
        }
      }
    }
    return true
  }

  private validateBillingInfo(): boolean {
    for (const product of this.subProductData.extra_param
      .product_sub_rate_list) {
      // 检查是否只有一个字段有值的情况
      const hasBillingType = !!product.billing_type
      const hasBillingCycle =
        product.billing_cycle !== null &&
        product.billing_cycle !== undefined &&
        product.billing_cycle !== ''

      // 如果只有一个字段有值，则不允许保存
      if (
        (hasBillingType && !hasBillingCycle) ||
        (!hasBillingType && hasBillingCycle)
      ) {
        this.$message({
          message:
            'Both billing type and billing cycle must be filled or left empty together',
          type: 'error'
        })
        return false
      }

      // 如果两个字段都有值，验证 billing_cycle 的范围
      if (hasBillingType && hasBillingCycle) {
        const cycle = Number(product.billing_cycle)
        if (isNaN(cycle) || cycle < 0 || cycle > 7) {
          this.$message({
            message: 'Billing cycle must be between 0 and 7',
            type: 'error'
          })
          return false
        }
      }
    }
    return true
  }
  private async submitData() {
    try {
      const isBillingValid = this.validateBillingInfo()
      if (!isBillingValid) {
        return
      }
      const isValid = this.validateRateList()
      if (!isValid) {
        return
      }
      this.loading = true
      await getSubProductConfig(this.subProductData).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        }
        this.loading = false
      })
    } catch (error) {}
  }

  private ensureBillingDefaults() {
    if (this.subProductData?.extra_param?.product_sub_rate_list) {
      this.subProductData.extra_param.product_sub_rate_list.forEach(
        (item: any) => {
          item.billing_type = item.billing_type || 'D'
          item.billing_cycle = Number(item.billing_cycle) || 0
        }
      )
    }
  }

  @Watch('subProduct')
  private onSubProductChange() {
    this.subProductData = this.subProduct
    this.ensureBillingDefaults()
  }

  mounted() {
    this.subProductData = this.subProduct
    // this.ensureBillingDefaults()
    console.log(this.subProductData)
  }
}
